import { render, staticRenderFns } from "./BrowseTotals.vue?vue&type=template&id=0fc00104&scoped=true"
import script from "./BrowseTotals.vue?vue&type=script&lang=ts"
export * from "./BrowseTotals.vue?vue&type=script&lang=ts"
import style0 from "./BrowseTotals.vue?vue&type=style&index=0&id=0fc00104&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc00104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc00104')) {
      api.createRecord('0fc00104', component.options)
    } else {
      api.reload('0fc00104', component.options)
    }
    module.hot.accept("./BrowseTotals.vue?vue&type=template&id=0fc00104&scoped=true", function () {
      api.rerender('0fc00104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseTotals.vue"
export default component.exports